import React from 'react';

import AuthCode from 'react-auth-code-input';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import FeedBack from '@components/lpc/Authentication/LeftSide/Login/FeedBack/FeedBack';
import Title from '@components/lpc/DoubleAuthentication/Title/Title';

import css from './ValidationBackupCodes.module.scss';

export type ValidationBackupCodesProps = {
    onSubmit: () => void;
    onChangeMode?: () => void;
    onSetCode: (string) => void;
    tfaCode: string;
    submissionState: {
        error: string;
        type: number;
        retries: number;
        isFeedBackVisible: boolean;
    };
    onHideFeedBack: () => void;
    isLoading: boolean;
};

const ValidationBackupCodes = ({
    onSubmit,
    onChangeMode,
    onSetCode,
    tfaCode,
    submissionState,
    onHideFeedBack,
    isLoading,
}: ValidationBackupCodesProps) => {
    const { t } = useTranslateLpc('lpc-double-authentication');

    return (
        <div className={css.validation_backup_codes_wrapper}>
            <Title text={t('connection.title')} hideDivider />
            <Text
                html
                htmlText={t('connection.backup-code.desc')}
                variant={'body_01'}
                color={'txt-primary'}
                customClass={css.text}
            />
            <div className={css.img_container}>
                <img
                    src={'/front-static/icons/authentication/phone.png'}
                    width={200}
                    height={245}
                    alt={'mobile'}
                    className={css.img_container__img}
                />
            </div>

            <Text variant={'body_01'} color={'txt-primary'} customClass={css.text}>
                {t('connection.backup-code.enter-code')}
            </Text>
            <AuthCode
                containerClassName={css.code_input}
                inputClassName={css.code_input__digit}
                length={6}
                autoFocus={true}
                allowedCharacters={'numeric'}
                onChange={(e) => onSetCode(e)}
            />
            {submissionState.isFeedBackVisible && (
                <FeedBack submissionState={submissionState} onHideFeedBack={() => onHideFeedBack()} />
            )}
            <div className={css.cta_container}>
                <Button
                    customClass={css.cta}
                    onClick={() => onChangeMode()}
                    size={'medium'}
                    variant={'secondary'}
                    type={'button'}
                    width={'230px'}
                >
                    {t('connection.backup-code.previous')}
                </Button>

                <Button
                    customClass={css.cta}
                    onClick={() => onSubmit()}
                    isLoading={isLoading}
                    isDisabled={!tfaCode || tfaCode.length !== 6 || submissionState.retries < 1 || isLoading}
                    size={'medium'}
                    variant={'primary'}
                    type={'submit'}
                >
                    {t('connection.validate')}
                </Button>
            </div>
        </div>
    );
};

export default ValidationBackupCodes;
